import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import React, { useEffect, useRef } from 'react';
const InlineStyle = ({
  children,
  id
}) => {
  // eslint-disable-next-line compat/compat
  const sheet = useRef(!document.adoptedStyleSheets ? new CSSStyleSheet() : document.createElement('style'));
  useEffect(() => {
    const stylesheet = sheet.current;
    if (stylesheet) {
      if (stylesheet instanceof CSSStyleSheet) {
        stylesheet.replaceSync(children);
      } else {
        stylesheet.textContent = children;
      }
    }
  }, [children]);
  useEffect(() => {
    const stylesheet = sheet.current;
    if (stylesheet) {
      if (stylesheet instanceof CSSStyleSheet) {
        document.adoptedStyleSheets = [...document.adoptedStyleSheets, stylesheet];
      } else {
        if (id) {
          stylesheet.id = id;
        }
        document.head.appendChild(stylesheet);
      }
    }
    return () => {
      if (stylesheet) {
        if (stylesheet instanceof CSSStyleSheet) {
          document.adoptedStyleSheets = document.adoptedStyleSheets.filter(s => s !== stylesheet);
        } else {
          document.head.removeChild(stylesheet);
        }
      }
    };
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null);
};
export { InlineStyle as default };